import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PendoIcon from '../../components/icon/pendo-icon.vue.js';
import PendoAppIcon from '../app-icon/pendo-app-icon.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import get from 'lodash/get.js';

var script = {
  name: 'PendoAppDisplay',
  components: {
    PendoIcon,
    PendoAppIcon
  },
  directives: {
    PendoTooltip
  },
  props: {
    apps: {
      type: [Array, Object],
      required: true
    },
    showCrossAppDisplay: {
      type: Boolean,
      default: false
    },
    showAppIcons: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    appItems() {
      const apps = Array.isArray(this.apps) ? this.apps : [this.apps];
      return apps.map(app => {
        let nameLabel = app.displayName || app.name || String(app.id);
        const trainingApplication = get(app, 'applicationFlags.trainingApplication');
        if (trainingApplication) {
          nameLabel = get(app, 'trainingAttributes.displayName') || nameLabel;
        }
        return _objectSpread2(_objectSpread2({}, app), {}, {
          nameLabel
        });
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-app-display.vue2.js.map
